import { juntar } from './ui'

/**
 * O nome do contato, com o do WhatsApp ao lado quando foram renomeados.
 *
 * "Thiago Ramos M3X (Thiago)" — o nome que a equipe deu vem primeiro, porque
 * é por ele que se procura e se reconhece o cliente; o do WhatsApp fica entre
 * parênteses e apagado, como referência.
 *
 * Sem isso, renomear apagava da tela quem o cliente diz ser. E é justamente
 * esse nome que ele usa ao se apresentar: "aqui é o Thiago" não bate com um
 * cartão escrito "Thiago Ramos M3X" e ninguém entende por quê.
 *
 * Some quando os dois são iguais: repetir o mesmo nome entre parênteses é
 * ruído em toda conversa que ninguém renomeou, que é a maioria.
 */
export function NomeDoContato({
  nome,
  nomeOriginal,
  className,
}: {
  nome: string
  nomeOriginal: string | null
  className?: string
}) {
  const mostrarOriginal = Boolean(nomeOriginal && nomeOriginal !== nome)

  return (
    /*
      `max-w-full` não é enfeite: sem ele este `inline-flex` cresce até o
      tamanho do conteúdo e vaza para fora do pai, porque nada o obriga a
      caber. No cartão da lista, "Thiago Ramos Nascimento M3X (Thiago Ramos do
      Nascimento)" pedia 352px num espaço de 184 e punha uma barra de rolagem
      horizontal na lista inteira — e o `truncate` do nome nunca chegava a
      valer, já que o container tinha espaço de sobra dentro de si mesmo.
    */
    <span className={juntar('inline-flex min-w-0 max-w-full items-baseline gap-1', className)}>
      <span className="min-w-0 truncate">{nome}</span>
      {mostrarOriginal ? (
        /*
          Mesma cor e peso do telefone e do "fora do CRM" logo abaixo: é
          informação de apoio, e competir com o nome principal desfaria o
          motivo de ter renomeado.

          Encolhe quatro vezes mais depressa que o nome. Apertados os dois, é o
          de apoio que deve ceder — some primeiro daqui e continua inteiro no
          título, ao passar o mouse.
        */
        <span
          className="min-w-0 shrink-[4] truncate text-xs font-normal text-tinta-400"
          title={`Nome que veio do WhatsApp: ${nomeOriginal}`}
        >
          ({nomeOriginal})
        </span>
      ) : null}
    </span>
  )
}
